<template>
	<div>
		<h2 class="text-subtitle">Shipping Addresses</h2>
		<ux-panel>

			<ux-panel-body v-if="loading">Loading...</ux-panel-body>

			<table v-else class="ux-table is-striped layout-fixed" cellpadding="0" cellspacing="0" border="0">
				<thead>
					<tr>
						<th class="buttons-cell"></th>
						<th>Name</th>
						<th>Street Address</th>
						<th>City</th>
						<th>Postal Code</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="addr in userAddressList" :key="addr.id">
						<td class="buttons-cell">
							<ux-btn circle color="text-primary" aria-label="Edit Address" title="Edit address" :to="`/profile/address/${addr.id}`"><i class="fas fa-edit"/></ux-btn>
							<ux-btn circle color="text-danger" aria-label="Delete Address" title="Delete address" @click="deleteAddress(addr.id)"><i class="fas fa-trash"/></ux-btn>
						</td>
						<td>{{ addr.name }}</td>
						<td>{{ addr.street1 }}</td>
						<td>{{ addr.city }}</td>
						<td>{{ addr.postal_code }}</td>
					</tr>
				</tbody>
			</table>
		</ux-panel>

		<ux-btn color="outline-primary" to="/profile/address/new">Add Address</ux-btn>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import api from 'frontend/api';
import alerts from 'common/alerts';

export default {
	data()
	{
		return {
			loading: true,
		}
	},

	computed: {
		...mapGetters('addresses', ['userAddressList']),
	},

	methods: {
		...mapActions('addresses', ['fetchUserAddresses']),

		async refreshList()
		{
			this.loading = true;

			try
			{
				await this.fetchUserAddresses();
			}
			finally
			{
				this.loading = false;
			}
		},

		async deleteAddress(id)
		{
			if (!await alerts.confirm('Are you sure you want to delete this address?', 'Delete Address'))
				return;

			this.loading = true;

			try
			{
				await api.delete(`/addresses/${id}`);
				await this.refreshList();
			}
			finally
			{
				this.loading = false;
			}
		}
	},

	mounted()
	{
		this.refreshList();
	}
}
</script>